define(
    'viewmodels/secured/explorer/details/tabs/actions/EmailAsShareAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "services/service.dialog",
        "services/service.documents",
        "services/config",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, dialogService, documentsService, config, i19n) {

        var EmailAsShareAction = (function (_super) {

            var _i19n = {
                action: {
                    name: "Email as Document Share",
                    message: "Email as Document Share"
                }
            };

            __extends(_Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-share", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {                    
                complete();
            }

            return _Action;

        })(Action);

        return EmailAsShareAction;

    });
